import { Spinner, Typography } from '@sonnen/web-ui';
import { useMobile } from '@sonnen/web-ui';
import styles from './LoadingSpinner.module.css';

export const LoadingSpinner = ({ text }: { text: string }) => (
  <div className={styles.loadingSpinner}>
    <Spinner size={useMobile() ? 'lg' : 'xl'} accessibilityLabel={text} />
    <div aria-hidden="true">
      <Typography.Body1>{text}</Typography.Body1>
    </div>
  </div>
);
